/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analogous`)
};

const es_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análoga`)
};

const de_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analog`)
};

const nl_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analoog`)
};

const fr_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analogue`)
};

const it_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analoga`)
};

const pt_br2_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análoga`)
};

const pt_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análoga`)
};

const ja_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類似色`)
};

const zh_cp_analogous = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邻近色`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_analogous = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_analogous(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_analogous", locale)
	if (locale === "en") return en_cp_analogous(inputs)
	if (locale === "es") return es_cp_analogous(inputs)
	if (locale === "de") return de_cp_analogous(inputs)
	if (locale === "nl") return nl_cp_analogous(inputs)
	if (locale === "fr") return fr_cp_analogous(inputs)
	if (locale === "it") return it_cp_analogous(inputs)
	if (locale === "pt-BR") return pt_br2_cp_analogous(inputs)
	if (locale === "pt") return pt_cp_analogous(inputs)
	if (locale === "ja") return ja_cp_analogous(inputs)
	return zh_cp_analogous(inputs)
};